import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "types";
import { initialState } from "./initialState";
import { supplierState } from "../types"

export const getSupplierState = (state:RootState) => state.SupplierState || initialState;


export const selectLoading = createSelector(
      [getSupplierState],
      (SupplierState:supplierState)=>SupplierState.loading
)

export const selectData = createSelector(
      [getSupplierState],
      (SupplierState:supplierState)=>SupplierState.data
)

export const selectError = createSelector(
      [getSupplierState],
      (SupplierState:supplierState)=>SupplierState.error
)
  

